const getStars = (value, maxStars) => {
  const FULL_STARS_QUANTITY = Math.floor(value);
  const FULL_STARS = Array(FULL_STARS_QUANTITY).fill('FULL');

  const HALF_STARS_QUANTITY = Math.ceil(value - FULL_STARS_QUANTITY);
  const HALF_STARS = Array(HALF_STARS_QUANTITY).fill('HALF');

  const EMPTY_STARS_QUANTITY = maxStars - HALF_STARS_QUANTITY - FULL_STARS_QUANTITY;
  const EMPTY_STARS = EMPTY_STARS_QUANTITY > 0 ? Array(EMPTY_STARS_QUANTITY).fill('EMPTY') : [];

  const STARS_QUANTITY_ARR = [FULL_STARS_QUANTITY, HALF_STARS_QUANTITY, EMPTY_STARS_QUANTITY];
  const STARS_QUANTITY = STARS_QUANTITY_ARR.reduce((acc, val) => acc + val, 0);
  const STARS = [...FULL_STARS, ...HALF_STARS, ...EMPTY_STARS].slice(0, maxStars);

  return {
    STARS,
    STARS_QUANTITY,
    FULL_STARS_QUANTITY,
    HALF_STARS_QUANTITY,
    EMPTY_STARS_QUANTITY,
  };
};

export default getStars;
